import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function sd0107(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SD0107_SUCCESS:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case actions.SET_SD0107_FAILURE:
      return state;
    default:
      return state;
  }
}
